import { gql } from '@apollo/client'

/**
 * @deprecated use fragment from here `src/gql/fragments/AdminModelConfiguration.graphql`
 */
export default gql`
    fragment AdminModelConfigurationDeprecatedDfmInspection on ModelConfigurationDfmInspection {
        id
        inspectionData
        isPublished
        quotedBy {
            id
            displayName
        }
        quotedAt
        quoteUpdatedBy {
            id
            displayName
        }
        quoteUpdatedAt
        updatedAt
        manualOverrideMpUnitPayout
        manualOverrideUnitAmount
    }

    fragment AdminModelConfigurationDeprecatedDfmInspectionsItem on ModelConfigurationDfmInspection {
        id
        inspectionData
        quantityLowerRange
        quantityUpperRange
        isQuantityRangeAvailable
        isPublished
        manualOverrideMpUnitPayout
        manualOverrideUnitAmount
        quotedBy {
            id
            displayName
        }
        quotedAt
        quoteUpdatedBy {
            id
            displayName
        }
        quoteUpdatedAt
        updatedAt
    }
    fragment adminModelConfigurationDeprecated on ModelConfiguration {
        id
        requiresOvermold
        additionalRequirements
        dfmInspections {
            ...AdminModelConfigurationDeprecatedDfmInspectionsItem
        }
        dfmInspection {
            ...AdminModelConfigurationDeprecatedDfmInspection
        }
        productionLeadTime {
            id
            priorityId
            productionDays
            primaryProductionDays
            shipDateEstimate {
                id
                validUntilDate
                shippedByDate
            }
        }
        process {
            id
            name
        }
        material {
            __typename
            ... on Material {
                id
                name
            }
            ... on UserEnteredMaterial {
                id
                name
            }
        }
        materialGrade
        color {
            id
            name
        }
        colorCode
        texture {
            id
            name
        }
        textureCode
        quantity
        errorCode
        updatedAt
        updatedBy {
            id
            email
            updatedAt
        }
        toolDetails {
            totalCost
            tools {
                id
                type
                diameter
                length
                ratio
                price
            }
        }
    }
`
